<template>
  <div class="max-w-6xl px-4 mx-auto mt-5 mb-20 md:px-0" v-if="companyDetails">
    <h1 class="pb-8 text-xl font-semibold">About {{ companyDetails.name }}</h1>
    <p
      class="leading-loose tracking-wide text-gray-500"
      v-html="companyDetails.description"
    ></p>
    <div class="mt-10 w-80">
      <div class="flex">
        <button
          class="w-40 px-2"
          :class="{
            'text-primary border-b-2 border-primary': showProperties,
            'text-gray-500': !showProperties,
          }"
          @click="
            showProperties = true;
            showAgents = false;
          "
        >
          Properties
        </button>
        <button
          class="w-40 px-2"
          :class="{
            'text-primary border-b-2 border-primary': showAgents,
            'text-gray-500': !showAgents,
          }"
          @click="
            showProperties = false;
            showAgents = true;
          "
        >
          Agents
        </button>
      </div>
      <hr class="" />
    </div>

    <div v-if="showProperties">
      <div class="mt-8" v-if="localProperties && localProperties.length > 0">
        <div class="flex flex-col">
          <div class="flex flex-row space-x-3">
            <div class="w-auto">
              <DropDown
                height="[48px]"
                buttonLabel="Buy"
                :menu-items="propertyTenureOptions || []"
                radius="lg"
                unique-identifier="buy"
                @menu-item-selected="handlePropertyTenureMenuItemSelected"
              />
            </div>
            <DropDown
              height="[48px]"
              buttonLabel="Featured"
              :menu-items="propertyFilters"
              radius="lg"
              unique-identifier="filters"
              @menu-item-selected="handleMenuItemSelected"
            />
          </div>
        </div>
        <div>
          <PropertyCard :properties="localProperties" :isFullWidth="true" />
        </div>
      </div>
    </div>

    <div v-if="showAgents">
      <div class="mt-5">
        <AgentCard :agentsDetails="agents" :isFullWidth="true" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PropertyCard from "@/features/properties/PropertyCard.vue";
import AgentCard from "@/features/find-broker/AgentsView.vue";
import DropDown from "@/components/form-components/DropDown.vue";

export default {
  components: {
    PropertyCard,
    DropDown,
    AgentCard,
  },
  props: {
    companyDetails: Object,
    properties: Object,
    agents: Object,
  },
  data() {
    return {
      localProperties: this.properties,
      isDropdownOpen: false,
      propertyFilters: this.$store.state.propertyFilters,
      propertyTenureOptions: null,
      base_url: this.$store.state.baseUrl,
      showProperties: true,
      showAgents: false,
    };
  },
  watch: {
    properties(newProperties) {
      this.localProperties = newProperties;
    },
  },
  mounted() {
    axios
      .get(`${this.base_url}property-tenure-options`)
      .then((response) => {
        this.propertyTenureOptions = response.data.data;
      })
      .catch((error) => console.log(error));
  },
  methods: {
    handleMenuItemSelected(payload) {
      let sortedValue = payload.itemId;
      axios
        .get(`${this.base_url}property-filters`, {
          params: {
            sort_by: sortedValue,
            company_id: this.$route.params.id,
          },
        })
        .then((response) => {
          this.localProperties = response.data.data;
          // console.log(this.localProperties);
        })
        .catch((error) => console.log(error));
    },
    handlePropertyTenureMenuItemSelected(payload) {
      let tenureId = payload.itemId;
      axios
        .get(`${this.base_url}property-filters`, {
          params: {
            property_tenure_option_id: tenureId,
            company_id: this.$route.params.id,
          },
        })
        .then((response) => {
          this.localProperties = response.data.data;
          // console.log(this.localProperties);
        })
        .catch((error) => console.log(error));
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
  },
};
</script>
